export class DivisaoEmpresa {
    codigoDiv: string;
    codigoEmp: string;
    descricaoDiv: string;
    codigoFil: string;
    dataCarga: string;
    cod_descricao: string;
  }